import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

export const onAddPinModalOpen: (
	isUpdateModal: boolean,
	source?: string,
) => AnalyticsEventPayload = (isUpdateModal: boolean, source?: string): AnalyticsEventPayload => {
	try {
		return {
			action: 'shown',
			actionSubject: isUpdateModal
				? 'aiSearchBookmarkOpenUpdateModal'
				: 'aiSearchBookmarkOpenAddModal',
			eventType: 'track',
			source,
		};
	} catch (error) {
		logger.error({
			feature: 'bookmarks',
			element: 'add-pin-modal',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onAddPinModalOpen',
		});
		return {};
	}
};
